import React from 'react'
import { MenuHeader, MenuLink } from 'transfix-ui/components/NavigationItemMenu'
import { Grid, makeStyles } from 'transfix-ui/core'
import { INavigationRoute } from '../../types'
import { getToolsMenuRoutes } from './utils'

const useToolsMenuStyles = makeStyles(theme => ({
  root: {
    minWidth: 'auto',
    [theme.breakpoints.up('md')]: {
      minWidth: 470,
    },
  },
}))

const getRoutes = (routes: INavigationRoute[]): INavigationRoute[] => {
  if (routes.length !== 0) {
    return routes
  }

  return getToolsMenuRoutes()
}

interface IToolsMenuProps {
  /**
   * Optionally override routes with prop
   */
  routes?: INavigationRoute[]
}

const ToolsMenu = ({ routes: routesProp = [] }: IToolsMenuProps) => {
  const routes = getRoutes(routesProp)
  const classes = useToolsMenuStyles()
  return (
    <div className={classes.root} data-test='ToolsMenu'>
      <Grid container spacing={4}>
        {routes.map(({ name, childRoutes = [] }) => {
          return (
            <Grid item xs={12} md='auto' key={name}>
              <MenuHeader>{name}</MenuHeader>
              {childRoutes.map(({ location, name }) => {
                return (
                  <MenuLink key={name} href={location}>
                    {name}
                  </MenuLink>
                )
              })}
            </Grid>
          )
        })}
      </Grid>
    </div>
  )
}

export default ToolsMenu
